import React from "react";
import projectsData from "../data/projectsData"; // Import the projects data
import "../CSS/Projects.css"; // Import corresponding CSS
import { Link } from "react-router-dom";
import liveDemoImg from "./assets/link.png";
import githubImg from "./assets/github.png";
import viewImg from "./assets/eye.png";

const Projects = () => {
  return (
    <div className="projects-container">
      <h1>My Projects</h1>
      <div className="projects-grid">
        {projectsData.map((project) => (
          <div key={project.id} className="project-card">
            <img src={project.images[0]} alt={project.name} className="project-image" />
            <h2>{project.name}</h2>
            <p>{project.description}</p>
            <div className="project-links">
              {project.liveLink && (
                <Link to={project.liveLink} className="project-button">
                  <img src={liveDemoImg} alt="Live Demo" />
                </Link>
              )}
              {project.githubLink && (
                <a href={project.githubLink} target="_blank" rel="noopener noreferrer" className="project-button">
                  <img src={githubImg} alt="GitHub" />
                </a>
              )}
              {project.id && (
                <Link to={`/projects/${project.id}`} className="project-button">
                  <img src={viewImg} alt="View Project" />
                </Link>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Projects;